import { autoinject, bindable } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ValidationController } from 'aurelia-validation';
import { StandardValidationBuilder } from 'lib/validation';
import { Models } from 'models/core';

@autoinject()
export class FloaterTypeForm {
  @bindable() floaterType: Models.FloaterType;
  @bindable() validationController: ValidationController;

  constructor(private t: I18N) {}

  protected attached() {
    console.log(this.validationController);
    const v = new StandardValidationBuilder(this.t);
    v.with(this.floaterType)
      .required('Name')
      .required('NameEn')
      //
      .required('Producer')
      //
      .required('CircumferenceOuterRing')
      .min('CircumferenceOuterRing', 0)
      //
      .required('DistanceBetweenLines')
      .min('DistanceBetweenLines', 0)
      //
      .required('NoBrackets')
      .min('NoBrackets', 0)
      .done();
  }
}
